import PRODUCT_CODES from '../constants/productCodes';
import ActionTypes from '../constants/actionTypes';
import { productDefaults } from './defaultStates';

export default function(state = productDefaults, action) {
  switch (action.type) {
    case ActionTypes.UPDATE[PRODUCT_CODES.PRODUCTS]:
      return {
        fetchSucceeded: true,
        values: action.payload,
        isFetching: false,
        selected: [],
        hasSelectedProducts: false
      };
    case ActionTypes.REQUEST[PRODUCT_CODES.PRODUCTS]:
      return { ...state, isFetching: true };
    case ActionTypes.FAILED2FETCH[PRODUCT_CODES.PRODUCTS]:
      return { ...state, fetchSucceeded: false, isFetching: false };
    case ActionTypes.SELECT[PRODUCT_CODES.PRODUCTS]:
      function findProduct(categories, key) {
        for (var i = 0; i < categories.length; i++) {
          for (var y = 0; y < categories[i].products.length; y++) {
            var product = categories[i].products[y];
            if (product.key === key) {
              // product found
              return {
                categoryIndex: i,
                category: categories[i],
                productIndex: y,
                product: product
              };
            }
          }
        }
        return null;
      }
      function findCategory(categories, key) {
        for (var i = 0; i < categories.length; i++) {
          if (categories[i].key === key) {
            return categories[i];
          }
        }
        return null;
      }
      function updateSelectedCount(properties, value) {
        for (var i = 0; i < properties.length; i++) {
          if (properties[i].name === 'selectedCount') {
            properties[i].value = value;
            return;
          }
        }
      }

      // TODO: optimize code --> add maps for lookup etc.
      var selected = state.selected;
      var categoriesContainer = state.values;
      var categories = categoriesContainer.categories;

      var resultProduct = findProduct(categories, action.payload.key);
      updateSelectedCount(
        resultProduct.product.properties,
        action.payload.value
      );

      var result;
      if (action.payload.value === 0) {
        // product not selected anymore, remove
        result = findProduct(selected, action.payload.key);
        if (result) {
          result.category.products.splice(result.productIndex, 1);

          // category has no products selected, remove
          if (result.category.products.length === 0) {
            selected.splice(result.categoryIndex, 1);
          }
        }
      } else {
        // add product + update selected value
        result = findProduct(selected, action.payload.key);
        if (result) {
          // product already selected, only update value
          updateSelectedCount(result.product.properties, action.payload.value);
        } else {
          var category = findCategory(selected, resultProduct.category.key);
          if (!category) {
            category = {
              categoryName: resultProduct.category.categoryName,
              columns: resultProduct.category.columns,
              key: resultProduct.category.key,
              products: []
            };
            selected.push(category);
          }
          category.products.push(resultProduct.product);
          updateSelectedCount(
            resultProduct.product.properties,
            action.payload.value
          );
        }
      }

      // update hasSelectedProducts
      var hasSelectedProducts = false;
      for (var i = 0; i < selected.length; i++) {
        if (selected[i].products.length > 0) {
          hasSelectedProducts = true;
          break;
        }
      }

      return {
        ...state,
        selected: selected,
        value: categoriesContainer,
        hasSelectedProducts: hasSelectedProducts
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_products.js